<template>
  <div class="review">
    <el-card shadow="never" class="review-card">
      <div class="filter-bar">
        <span class="filter-label">筛选状态:</span>
        <el-radio-group v-model="reviewFilter" size="small" @change="fetchReviews">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button label="0">待审核 ({{ pendingCount }})</el-radio-button>
          <el-radio-button label="1">已通过</el-radio-button>
          <el-radio-button label="2">已驳回</el-radio-button>
        </el-radio-group>
      </div>

      <el-table :data="reviewList" style="width: 100%;" border stripe v-loading="loading">
        <el-table-column prop="id" label="ID" width="100" />
        <el-table-column prop="name" label="商品名" min-width="200" />
        <el-table-column prop="branch" label="所属分身" width="150">
          <template slot-scope="scope">
            <span class="branch-name">{{ scope.row.branch }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="售价(365n)" width="130">
          <template slot-scope="scope">
            <span class="price-bold">¥{{ scope.row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column label="提报时间" width="180">
          <template slot-scope="scope">{{ scope.row.submitTime | formatDateTime }}</template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.status === '待审核' ? 'danger' : scope.row.status === '已通过' ? 'success' : 'info'"
              size="small"
            >
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <template v-if="scope.row.status_code === 0">
              <el-button type="text" style="color: #67c23a;" size="small" @click="handleAudit(scope.row, 'approve')">审核通过</el-button>
              <el-button type="text" style="color: #E4393C;" size="small" @click="handleAudit(scope.row, 'reject')">驳回</el-button>
            </template>
            <span v-else class="processed-text">已处理</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrap">
        <span>共 {{ total }} 条记录</span>
        <el-pagination
          background layout="prev, pager, next"
          :total="total" :page-size="limit"
          :current-page.sync="page"
          @current-change="fetchReviews"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { getReviews, approveReview, rejectReview } from '@/api'

export default {
  name: 'Review',
  data() {
    return {
      reviewFilter: '',
      reviewList: [],
      total: 0,
      page: 1,
      limit: 10,
      pendingCount: 0,
      loading: false
    }
  },
  mounted() {
    this.fetchReviews()
  },
  methods: {
    fetchReviews() {
      this.loading = true
      const params = { page: this.page, limit: this.limit }
      if (this.reviewFilter !== '') params.audit_status = this.reviewFilter

      getReviews(params).then(res => {
        this.reviewList = res.list || []
        this.total = res.total || 0
        this.pendingCount = res.pendingCount || 0
      }).catch(() => {
        this.$message.error('获取审核列表失败')
      }).finally(() => {
        this.loading = false
      })
    },
    handleAudit(row, action) {
      const actionText = action === 'approve' ? '通过' : '驳回'
      this.$confirm(`确认${actionText}该商品报单？`, '审核确认', {
        type: action === 'approve' ? 'success' : 'warning'
      }).then(() => {
        const apiCall = action === 'approve'
          ? approveReview({ id: parseInt(row.id.replace('R-', '')) })
          : rejectReview({ id: parseInt(row.id.replace('R-', '')) })

        apiCall.then(() => {
          this.$message.success(`已${actionText}`)
          this.fetchReviews()
        }).catch(() => {
          this.$message.error(`${actionText}失败`)
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.review-card { border-radius: 8px; }
.filter-bar { display: flex; align-items: center; gap: 16px; padding: 0 0 16px; border-bottom: 1px solid #f0f0f0; margin-bottom: 16px; }
.filter-label { font-size: 14px; color: #606266; font-weight: 500; }
.branch-name { color: #409EFF; }
.price-bold { font-weight: bold; }
.processed-text { color: #c0c4cc; }
.pagination-wrap { display: flex; align-items: center; justify-content: space-between; padding: 16px 0 0; font-size: 13px; color: #909399; }
</style>
